import { render, staticRenderFns } from "./PatientAsam.vue?vue&type=template&id=1ad816cf&"
import script from "./PatientAsam.vue?vue&type=script&lang=js&"
export * from "./PatientAsam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports